import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils';

import { FileModel, fileSchema } from './FileModel';

export type NurseReinclusionNudge = {
  reinclusion_request_active: boolean;
  last_cp_end?: string;
  should_ask_for_nudge: boolean;
  nurse_first_name?: string;
  nurse_last_name?: string;
  nurse_profile_picture?: FileModel;
};

export const nurseReinclusionNudgeSchema: Schema<NurseReinclusionNudge> =
  z.object({
    reinclusion_request_active: z.boolean(),
    last_cp_end: cz.optional(z.string()),
    should_ask_for_nudge: z.boolean(),
    nurse_first_name: cz.optional(z.string()),
    nurse_last_name: cz.optional(z.string()),
    nurse_profile_picture: cz.optional(fileSchema),
  });
